import type { GameDefinition } from '../platform/types';

export const games: GameDefinition[] = [
  {
    id: 'mossfire',
    title: 'Mossfire',
    kicker: 'Keep the last light moving.',
    genre: 'Survivor action',
    description: 'Build a wild spell loadout and outlast the thicket before its ancient warden wakes.',
    playTime: '10 min',
    difficulty: 'Medium',
    controls: ['Move: WASD / drag', 'Dash: Space / tap'],
    palette: { ink: '#18342c', field: '#d5eaa5', accent: '#f15d3c', spark: '#ffe46d' },
    component: () => import('./mossfire/MossfireGame'),
  },
  {
    id: 'drift-courier',
    title: 'Drift Courier 3D',
    kicker: 'Late parcels. Loud corners.',
    genre: '3D arcade driving',
    description: 'Thread a toy city, chain drifts into boost, and keep fragile cargo intact through rush hour.',
    playTime: '12 min',
    difficulty: 'Medium',
    controls: ['Drive: WASD / arrows', 'Drift: Space', 'Recover: R'],
    palette: { ink: '#162946', field: '#9fd7e5', accent: '#f45137', spark: '#f6d84a' },
    component: () => import('./drift-courier/DriftCourierGame'),
  },
  {
    id: 'dinky-diner',
    title: 'Dinky Diner',
    kicker: 'Tiny kitchen. Huge lunch rush.',
    genre: 'Kitchen management',
    description: 'Arrange stations, route your cook, and turn a tabletop diner into a five-star machine.',
    playTime: '12 min',
    difficulty: 'Easy',
    controls: ['Route: click / tap', 'Move: WASD'],
    palette: { ink: '#4a2335', field: '#ffd3b4', accent: '#d83845', spark: '#f7e46c' },
    component: () => import('./dinky-diner/DinkyDinerGame'),
  },
  {
    id: 'hexhold',
    title: 'Hexhold',
    kicker: 'Draft. Merge. Hold the road.',
    genre: 'Merge tower defense',
    description: 'Trade coverage for power as a clockwork procession tests every edge of your hex fortress.',
    playTime: '12 min',
    difficulty: 'Hard',
    controls: ['Place / merge: click or tap', 'Abilities: 1 / 2'],
    palette: { ink: '#29243e', field: '#d8c9ef', accent: '#ef6d3d', spark: '#bbef66' },
    component: () => import('./hexhold/HexholdGame'),
  },
  {
    id: 'twenty-one-terrors',
    title: 'Twenty-One Terrors',
    kicker: 'Hit the monster. Not twenty-two.',
    genre: 'Blackjack roguelite',
    description: 'Turn blackjack hands into attacks, twist suit powers, and read every monster before it strikes.',
    playTime: '15 min',
    difficulty: 'Medium',
    controls: ['Hit / stand: click or tap', 'Keyboard: H / S'],
    palette: { ink: '#251b22', field: '#e4d7c5', accent: '#c92f42', spark: '#e2ad32' },
    component: () => import('./twenty-one-terrors/TwentyOneTerrorsGame'),
  },
  {
    id: 'orbital-salvage',
    title: 'Orbital Salvage',
    kicker: 'Miss beautifully. Correct once.',
    genre: 'Gravity puzzle',
    description: 'Slingshot around pocket planets, snatch lost cargo, and spend one precious burn to make it home.',
    playTime: '12 min',
    difficulty: 'Medium',
    controls: ['Launch: drag and release', 'Burn: click / tap', 'Reset: R'],
    palette: { ink: '#171d3a', field: '#b9c7f1', accent: '#ee5b38', spark: '#c9f159' },
    component: () => import('./orbital-salvage/OrbitalSalvageGame'),
  },
  {
    id: 'echo-shift',
    title: 'Echo Shift',
    kicker: 'Your best teammate is eight seconds ago.',
    genre: 'Time-clone platformer',
    description: 'Record a move, rewind, and cooperate with your echo through a dozen precise clockwork rooms.',
    playTime: '12 min',
    difficulty: 'Hard',
    controls: ['Move: A / D', 'Jump: Space', 'Echo: E', 'Reset: R'],
    palette: { ink: '#132c31', field: '#a9e1d7', accent: '#f04d58', spark: '#f4de65' },
    component: () => import('./echo-shift/EchoShiftGame'),
  },
];

export function getGame(id: string | null) {
  return games.find((game) => game.id === id) ?? null;
}
